// Environment configuration based on domain detection

interface EnvironmentConfig {
  name: 'production' | 'staging';
  supabaseUrl: string;
  supabaseAnonKey: string;
  supabaseProjectId: string;
  emailDomain: string;
  sentryDsn: string;
}

const PRODUCTION_DOMAINS = [
  'getgreenlight.lovable.app',
  'getgreenlight.net',
  'www.getgreenlight.net',
  'app.getgreenlight.net',
];

const SENTRY_DSN = 'https://00caac77ecadf348c6f6fceba13a3080@o4511518373969920.ingest.us.sentry.io/4511518432493568';

const ENVIRONMENTS: Record<'production' | 'staging', EnvironmentConfig> = {
  production: {
    name: 'production',
    supabaseUrl: 'https://ercyagfmgsxcssjdpwwn.supabase.co',
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVyY3lhZ2ZtZ3N4Y3NzamRwd3duIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY3NjcwODcsImV4cCI6MjA4MjM0MzA4N30.FB2wc-AcmTi62M3Xj3PO6_kmNK0Gafroc0Ptq9Z_1Xs',
    supabaseProjectId: 'ercyagfmgsxcssjdpwwn',
    emailDomain: 'app.getgreenlight.net',
    sentryDsn: SENTRY_DSN,
  },
  staging: {
    name: 'staging',
    supabaseUrl: 'https://xhihejadpyjdzdsupvwv.supabase.co',
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhoaWhlamFkcHlqZHpkc3Vwdnd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcxMDQ5OTIsImV4cCI6MjA4MjY4MDk5Mn0.ETrwO8B3w9kSUC4ZPMxOA8ktHu3JFkFq0GL4Ay5VpsU',
    supabaseProjectId: 'xhihejadpyjdzdsupvwv',
    emailDomain: 'staging.getgreenlight.net',
    sentryDsn: SENTRY_DSN,
  },
};

function detectEnvironment(): 'production' | 'staging' {
  if (typeof window === 'undefined') return 'staging';

  const hostname = window.location.hostname;
  return PRODUCTION_DOMAINS.includes(hostname) ? 'production' : 'staging';
}

export function getEnvironment(): EnvironmentConfig {
  return ENVIRONMENTS[detectEnvironment()];
}

export function isProduction(): boolean {
  return detectEnvironment() === 'production';
}

export function isStaging(): boolean {
  return detectEnvironment() === 'staging';
}

export function getSentryConfig(): { dsn: string; environment: 'production' | 'staging' } {
  const env = getEnvironment();
  return { dsn: env.sentryDsn, environment: env.name };
}
